import shortid from 'shortid';
import { createReducer } from 'typesafe-actions';
import slugify from '../common/utils/slugify';
import { ADD_ARRAY_ITEM, CHANGE_FIELD } from '../schema-form/action-types';
import { STEP_COLOR_PALETTE, WORKFLOW_FORM_NAME, WORKFLOW_UPDATE_FORM } from './constants';

export type Action = {
  type: string;
  meta: {
    formName?: string;
    path: Array<string | number>;
    index?: number;
  };
  payload: any;
};

const isWorkflowForm = (formName: string | undefined): boolean =>
  Boolean(formName === WORKFLOW_FORM_NAME || formName === WORKFLOW_UPDATE_FORM);

export function changeField(state: any, { meta, payload }: Action): any {
  if (!isWorkflowForm(meta.formName)) {
    return state;
  }

  const isNew = meta.formName === WORKFLOW_FORM_NAME;
  if (isNew && meta.path[0] === 'title') {
    return state.setIn(['data', 'name'], slugify(payload));
  }

  if (meta.path[0] === 'steps' && meta.path[2] === 'title') {
    return state
      .setIn(['data', meta.path[0], meta.path[1], 'name'], slugify(payload))
      .setIn(['data', meta.path[0], meta.path[1], 'key'], shortid.generate());
  }

  return state;
}

export function handleNewStep(state: any, { meta }: Action): any {
  if (!isWorkflowForm(meta.formName)) {
    return state;
  }

  const steps = state.getIn(['data', 'steps']);
  const lastIndex = steps ? steps.size - 1 : 0;
  return state.mergeIn(['data', 'steps', lastIndex], {
    live: false,
    color: STEP_COLOR_PALETTE[lastIndex % STEP_COLOR_PALETTE.length]
  });
}

export default createReducer<any, Action>(
  {},
  {
    [CHANGE_FIELD]: changeField,
    [ADD_ARRAY_ITEM]: handleNewStep
  }
);
